import { useEffect, useState, useMemo } from "react";
import { Container, ListGroup, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useTitle } from "./context";
import { SpellBookBackend } from "./backend";
import { fetchClasses, loadState, storeState } from "./utilities";

import "bootstrap/dist/css/bootstrap.min.css";


const CLASSES_PAGE_KEY = "classes-page";


export function ClassesPage({navbarHeight}) {
    const navigate = useNavigate();
    const { setTitle } = useTitle();
    const [classes, setClasses] = useState([]);
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [error, setError] = useState("");

    const getStateJson = () => {
        return {
            classes: classes
        };
    };

    const setStateJson = (s) => {
        setClasses(s.classes);
    };
    
    useEffect(() => {
        setTitle("Classi");
    }, [setTitle]);

    useEffect(() => {
        if (classes && classes.length > 0) {
            storeState(CLASSES_PAGE_KEY, getStateJson());
        }
    }, [classes]);
    
    const fetchData = async () => {
        setClasses(await fetchClasses());
    }

    useEffect(() => {
        let mounted = true;
        (
            async () => {
                try {
                    setStatus("loading");
                    const s = loadState(CLASSES_PAGE_KEY);
                    if (s?.classes?.length > 0) {
                        setStateJson(s);
                    }
                    else {
                        await fetchData();
                    }
                    if (mounted) {
                        setStatus("success");
                    }
                }
                catch {
                    if (mounted) {
                        setError("Failed to load items.");
                        setStatus("error");
                    }
                }
            }
        )();
        return () => {
            mounted = false;
        };
    }, []);

    const navigateToClass = (classId) => {
        navigate(`/classes/${classId}`);
    };

    const content = useMemo(() => {
        if (status === "loading") {
            return (
                <div className="d-flex justify-content-center py-5">
                    <Spinner animation="border" role="status" aria-label="Loading items" />
                </div>
            );
        }
        if (status === "error") {
            return <Alert variant="danger" className="my-3">{error}</Alert>;
        }
        if (classes.length === 0) {
            return <Alert variant="secondary" className="my-3">No classes found.</Alert>;
        }

        //else

        return (
            <ListGroup as="ul" variant="flush" className="shadow-sm bg-white rounded mt-3 mb-3">
                {classes.map((cls) => {
                    return (
                        <ListGroup.Item
                        as="li"
                        key={cls.id}
                        action
                        onClick={() => navigateToClass(cls.id)}
                        className="d-flex align-items-center gap-3 py-3"
                        role="button"
                        aria-label={`Open ${cls.name}`}
                        >
                            <span className="fw-medium">
                                {cls.name}
                            </span>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        );
    }, [status, classes, error, navigate]);

    const containerMargin = `${navbarHeight}px`;
    const containerHeight = `calc(100vh - ${navbarHeight}px)`;

    return (
        <Container
        fluid
        className="bg-light"
        style={{
            marginTop: containerMargin,
            height: containerHeight,
            overflowY: "auto"
        }}>
            {content}
        </Container>
    );
}
